import { render } from "./ChartPool.vue?vue&type=template&id=0028f4b9&scoped=true&ts=true"
import script from "./ChartPool.vue?vue&type=script&lang=ts"
export * from "./ChartPool.vue?vue&type=script&lang=ts"

import "./ChartPool.vue?vue&type=style&index=0&id=0028f4b9&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0028f4b9"]])

export default __exports__